<template>
  <el-select v-model="selectedRange" placeholder="Please select">
    <el-option
      v-for="key in Object.keys(timeRanges)"
      :key="key"
      :label="key"
      :value="key">
    </el-option>
  </el-select>
</template>

<script>
import moment from 'moment';

export default {
  data: () => ({
    range: 'any time',
    timeRanges: {
      'any time': {
        start: null,
        end: null,
      },
      'date range': {
        start: null,
        end: null,
      },
      'the last hour': {
        start: () => moment().subtract(1, 'hours'),
        end: () => moment(),
      },
      today: {
        start: () => moment().startOf('day'),
        end: () => moment(),
      },
      yesterday: {
        start: () =>
          moment()
            .subtract(1, 'days')
            .startOf('day'),
        end: () => moment().startOf('day'),
      },
      'the past week': {
        start: () =>
          moment()
            .subtract(1, 'weeks')
            .startOf('day'),
        end: () => moment(),
      },
      'the past month': {
        start: () =>
          moment()
            .subtract(1, 'months')
            .startOf('day'),
        end: () => moment(),
      },
      'the past 2 months': {
        start: () =>
          moment()
            .subtract(2, 'months')
            .startOf('day'),
        end: () => moment(),
      },
      'the past 3 months': {
        start: () =>
          moment()
            .subtract(3, 'months')
            .startOf('day'),
        end: () => moment(),
      },
      'the past year': {
        start: () =>
          moment()
            .subtract(1, 'years')
            .startOf('day'),
        end: () => moment(),
      },
      'the past 2 years': {
        start: () =>
          moment()
            .subtract(2, 'years')
            .startOf('day'),
        end: () => moment(),
      },
      'the past 3 years': {
        start: () =>
          moment()
            .subtract(3, 'years')
            .startOf('day'),
        end: () => moment(),
      },
    },
  }),
  computed: {
    selectedRange: {
      get() {
        return this.range;
      },
      set(newRange) {
        const showdateRangeDialog = newRange === 'date range';
        this.$emit('onDateRangeSelected', showdateRangeDialog);
        this.range = newRange;

        const timeRange = this.timeRanges[newRange];
        const start = timeRange.start ? timeRange.start().toISOString() : null;
        const end = timeRange.end ? timeRange.end().toISOString() : null;

        this.$emit('onRangeChanged', { start, end });
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// TimeRangeSelect.vue?2dbb4e6f